import { Tooltip } from 'antd';
import { DEPLOYMENTS } from 'app/config';
import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { theme } from 'styles/colors';
import './button-crx-agent.scss';

export function CRxAgentButtonWithContext() {
  /**
   * We use `useRouteMatch` here because the context of this component is
   * outside of the PatientRouter and the `:patientId` parameter is not accessible through `useParams`
   */
  const params = useRouteMatch<{ patientId: string }>(`/*/:patientId/*`);
  return <CRxAgentButton patientId={params?.params.patientId ?? null} />;
}

export function CRxAgentButton(props: { patientId: string | null }) {
  const route = useMemo(() => {
    const url = new URL(DEPLOYMENTS.CRX_AGENT_BASE_PATH);
    if (props.patientId === null) {
      url.pathname = '/';
    } else {
      url.pathname = `chat/patient/${props.patientId}`;
    }

    return url.toString();
  }, [props.patientId]);
  const toolTip =
    props.patientId === null
      ? 'Click to try our new beta tool'
      : 'Explore these results with our new beta tool';

  return (
    <Tooltip title={toolTip} placement="right">
      <a
        target="_current"
        href={route}
        className="plausible-event-name=oliverai:click"
        style={{
          /**
           * WARNING: Setting background image here because the inline styles of BaseButton override the styles.
           * TODO: Fix styling in the project
           */

          display: 'inline-flex',
          justifyContent: 'space-between',
          // width: '100%',
          flex: 1,
          alignItems: 'center',
          gap: 5
        }}
      >
        Oliver AI
        <div
          style={{
            borderRadius: '100rem',
            border: `2px solid ${theme.primary}`,
            color: theme.primary,
            lineHeight: '0rem',
            margin: 0,
            paddingLeft: 4,
            paddingRight: 4,
            maxWidth: 200,
            height: 20,
            fontSize: 10,
            overflow: 'visible',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          Beta
        </div>
      </a>
    </Tooltip>
  );
}
